module.exports = __webpack_public_path__ + "static/img/10.bb46c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/10.png
// module id = jZp1
// module chunks = 0